module.exports = __webpack_public_path__ + "static/grecianIsleRules-build-min.adcede8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructional/grecianIsleRules-build-min.jpg
// module id = 145
// module chunks = 66570062548345 213534597649335